import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {UserGroupBO} from "./UserGroupBO";
import {esWB_User_Group} from "../PA.Core/PAdbSchema";


export class UserGroupBOValidations {


    static Validate(aBO: UserGroupBO): Promise<void> {


        return new Promise<void>((resolve, error) => {

            if (_.isEmpty(aBO.WB_UserGroup.cif.USRGRP_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyid',
                        type: MessageType.Error,
                        title: "User Group ID cannot be empty.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyid')
            }
            if (_.isEmpty(aBO.WB_UserGroup.cif.USRGRP_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "User Group Name cannot be empty.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            let allSalesAreas=_.filter(aBO.WB_UserGroup.WB_UserGroupSalesAreaRows,aRow=>aRow.isActive)
            if(allSalesAreas.length==0){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptySA',
                        type: MessageType.Error,
                        title: "User Group should have at least one SalesArea.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptySA')
            }

            // duplicate User Groups
            aBO.dbContext.findAll(esWB_User_Group,
                {where:{
                        WB_USRGRP_ID:{neq:aBO.WB_UserGroup.cif.WB_USRGRP_ID},
                        WB_USRGRPM_ID:aBO.WB_UserGroup.cif.WB_USRGRPM_ID,
                        USRGRP_ID:aBO.WB_UserGroup.cif.USRGRP_ID
                }
                })
                .then((results)=>{

                    if(results.length> 0){
                        aBO.ValidateMessageProvider.addMessage(
                            {
                                code: 'duplicateID',
                                type: MessageType.Error,
                                title: "User Group ID already exists.",
                                description: "",
                                subtitle: "",
                                count: 0
                            })
                    } else {
                        aBO.ValidateMessageProvider.removeMessage('duplicateID')
                    }

            })



            resolve()
        })
    }

}
